import gql from 'graphql-tag';

export default gql`
  fragment scoreContractFragment on ScoreContract {
    id
    isActive
    canCreateTaskFromScoreChange
  }
`;
